// 出庫

// 到着状態
const ARRIVAL_STATUS = {
  BEFORE_ARRIVAL: 1,
  AFTER_ARRIVAL: 2,
  CANCEL: 99
}

const STATUS_HISTORY_LABEL = {
  BEFORE_ARRIVAL: 'stock-move.stock-move_send-comp',
  AFTER_ARRIVAL: 'storage.storage_arrived',
  CANCEL: 'order.order_invalid'
}

export default {
  ARRIVAL_STATUS,
  STATUS_HISTORY_LABEL
}
